import { Button } from 'components/Button'
import { banStatusStrings } from 'constants/strings'
import {
  getOrganizationSortLabel,
  nextOrganizationSort,
  ORGANIZATION_CARD_SORT_KEYS,
  type OrganizationSort,
} from './banStatusView'

type OrganizationBreakdownSortProps = {
  sort: OrganizationSort
  onChange: (sort: OrganizationSort) => void
}

const strings = banStatusStrings.organizations.sort
const selectClassName =
  'h-11 w-full rounded-2xl border border-border/80 bg-white/80 px-3 text-sm text-ink shadow-sm focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30 disabled:opacity-50'

export function OrganizationBreakdownSort({
  sort,
  onChange,
}: OrganizationBreakdownSortProps) {
  return (
    <div className="mb-3 flex flex-wrap items-end gap-3">
      <label className="grid min-w-0 flex-[1_1_180px] gap-2 text-xs font-semibold text-ink">
        {strings.field}
        <select
          className={selectClassName}
          value={sort?.key ?? ''}
          onChange={(event) => {
            const key = ORGANIZATION_CARD_SORT_KEYS.find(
              (key) => key === event.target.value,
            )
            onChange(key ? nextOrganizationSort(null, key) : null)
          }}
        >
          <option value="">{strings.default}</option>
          {ORGANIZATION_CARD_SORT_KEYS.map((key) => (
            <option key={key} value={key}>
              {getOrganizationSortLabel(key)}
            </option>
          ))}
        </select>
      </label>
      <label className="grid flex-[0_1_100px] gap-2 text-xs font-semibold text-ink">
        {strings.direction}
        <select
          className={selectClassName}
          value={sort?.direction ?? ''}
          disabled={sort === null}
          onChange={(event) => {
            if (sort) {
              onChange({
                ...sort,
                direction: event.target.value === 'asc' ? 'asc' : 'desc',
              })
            }
          }}
        >
          {sort === null && <option value="">{strings.noDirection}</option>}
          <option value="asc">{strings.ascending}</option>
          <option value="desc">{strings.descending}</option>
        </select>
      </label>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={sort === null}
        onClick={() => onChange(null)}
      >
        {strings.reset}
      </Button>
    </div>
  )
}
